function Authentication($rootScope, $state, authService) {
  $rootScope.$on('$stateChangeStart', (event, toState, toParams) => {
    _handleAuthentication(event, toState, toParams);
  });

  function _handleAuthentication(event, toState) {
    if (toState.authenticate === true && !authService.isLoggedIn()) {
      event.preventDefault(); // prevent the state change

      if (toState.name === 'accountSetup') {
        $state.go('signup');
      } else {
        $state.go('login');
      }
    }
  }
}

Authentication.$inject = [
  '$rootScope',
  '$state',
  'jsSdk.auth'
];

export default Authentication;



// WEBPACK FOOTER //
// ./src/authentication.js